export default {
  'common': {
    'add': '追加',
    'cancel': 'キャンセル',
    'description': '説明',
    'delete': '削除',
    'title': '題名',
    'save': '保存する',
    'faq': 'よくある質問',
    'contact': 'お問い合わせ',
    'tos': '利用規約',
    'policy': '個人情報保護方針'
  },
  'board': {
    'titlePlaceholder': 'このカードのタイトルを入力してください',
    'deleteDescription': 'このカードを削除してもよろしいですか？',
    'editCard': 'カードを編集する',
    'deleteCard': 'カードを削除する',
    'state': {
      'TODO': 'やること',
      'INPROGRESS': '進行中',
      'TESTING': 'テスト',
      'DONE': '完了'
    }
  },
  'chat': {
    'online': 'オンラインユーザー（{count}）',
    'addChannel': 'チャネルを追加',
    'channel': 'チャンネル|チャンネル',
    'message': 'メッセージ'
  },
  'email': {
    'compose': 'Eメールの作成',
    'send': '送信',
    'subject': '件名',
    'labels': 'ラベル',
    'emptyList': '空のメーリングリスト',
    'inbox': '受信トレイ',
    'sent': '送信済み',
    'drafts': 'ドラフト',
    'starred': 'スター付き',
    'trash': 'ゴミ箱',
    'work': '作業',
    'invoice': '請求書'
  },
  'todo': {
    'addTask': 'タスクの追加',
    'tasks': 'タスク',
    'completed': '完了',
    'labels': 'ラベル'
  },
  'dashboard': {
    'activity': 'アクティビティ',
    'weeklySales': 'ウィークリーセールス',
    'sales': '販売',
    'recentOrders': '最近の注文',
    'sources': 'トラフィックソース',
    'lastweek': '対先週',
    'orders': '注文',
    'customers': 'お客様',
    'tickets': 'サポートチケット',
    'viewReport': 'レポートを見る'
  },
  'usermenu': {
    'profile': 'プロフィール',
    'signin': 'サインイン',
    'dashboard': 'ダッシュボード',
    'signout': 'サインアウト'
  },
  'error': {
    'notfound': 'ページが見つかりません',
    'other': 'エラーが発生しました'
  },
  'check': {
    'title': '新しいパスワードを設定する',
    'backtosign': 'サインインに戻る',
    'newpassword': '新しいパスワード',
    'button': '新しいパスワードを設定してサインインする',
    'error': 'アクションリンクが無効です',
    'verifylink': 'リンクを確認しています...',
    'verifyemail': 'メールアドレスを確認しています...',
    'emailverified': 'メール確認済み！リダイレクト...'
  },
  'forgot': {
    'title': 'パスワードをお忘れですか？',
    'subtitle': 'アカウントのメールアドレスを入力すると、パスワードをリセットするためのリンクが送信されます。',
    'email': 'Eメール',
    'button': 'パスワードリセットのリクエスト',
    'backtosign': 'サインインに戻る'
  },
  'login': {
    'title': 'サインイン',
    'email': 'Eメール',
    'password': 'パスワード',
    'button': 'サインイン',
    'orsign': 'またはでサインイン',
    'forgot': 'パスワードをお忘れですか？',
    'noaccount': 'アカウントをお持ちではありませんか？',
    'create': 'ここで作成します',
    'error': 'メールとパスワードの組み合わせが無効です'
  },
  'register': {
    'title': 'アカウントを作成する',
    'name': 'フルネーム',
    'email': 'Eメール',
    'password': 'パスワード',
    'button': 'アカウントを作成する',
    'orsign': 'またはでサインアップ',
    'agree': 'サインアップすると、',
    'account': 'すでにアカウントをお持ちですか？',
    'signin': 'サインイン'
  },
  'utility': {
    'maintenance': 'メンテナンス中'
  },
  'faq': {
    'call': '他に質問がありますか？お問い合わせください'
  },
  'ecommerce': {
    'products': '製品',
    'filters': 'フィルター',
    'collections': 'コレクション',
    'priceRange': '価格帯',
    'customerReviews': 'カスタマーレビュー',
    'up': '以上',
    'brand': 'ブランド',
    'search': '製品を検索する',
    'results': '結果（{1}の{0}）',
    'orders': '注文',
    'shipping': '運送',
    'freeShipping': '送料無料',
    'inStock': '在庫あり',
    'quantity': '量',
    'addToCart': 'カートに追加',
    'buyNow': '今買う',
    'price': '価格',
    'about': 'このアイテムについて',
    'description': '説明',
    'reviews': 'レビュー',
    'details': '製品詳細',
    'cart': 'カート',
    'summary': '注文の概要',
    'total': '合計',
    'discount': 'ディスカウント',
    'subtotal': '小計',
    'continue': 'ショッピングを続ける',
    'checkout': 'チェックアウト'
  },
  'menu': {
    'search': '検索（フォーカスするには「ctrl + /」を押します）',
    'dashboard': 'ダッシュボード',
    'logout': 'ログアウト',
    'profile': 'プロフィール',
    'blank': '空白ページ',
    'pages': 'ページ',
    'others': 'その他',
    'email': 'Eメール',
    'chat': 'チャット',
    'todo': 'やること',
    'board': 'タスクボード',
    'users': 'ユーザー',
    'usersList': 'リスト',
    'usersEdit': '編集',
    'ecommerce': 'eコマース',
    'ecommerceList': '製品',
    'ecommerceProductDetails': '製品詳細',
    'ecommerceOrders': '注文',
    'ecommerceCart': 'カート',
    'auth': '認証ページ',
    'authLogin': 'サインイン/ログイン',
    'authRegister': 'サインアップ/登録',
    'authVerify': 'Eメールを確認します',
    'authForgot': 'パスワードをお忘れですか',
    'authReset': 'パスワードを再設定する',
    'errorPages': 'エラーページ',
    'errorNotFound': '見つかりません/ 404',
    'errorUnexpected': '予期しない/ 500',
    'utilityPages': 'ユーティリティページ',
    'utilityMaintenance': 'メンテナンス',
    'utilitySoon': '近日公開',
    'utilityHelp': 'よくある質問/ヘルプ',
    'levels': 'メニューレベル',
    'disabled': 'メニュー無効',
    'docs': 'ドキュメンテーション',
    'feedback': 'フィードバック',
    'support': 'サポート',
    'landingPage': 'ランディングページ',
    'pricingPage': '価格ページ'
  },
  '$vuetify': {
    'badge': 'バッジ',
    'close': '閉じる',
    'dataIterator': {
      'noResultsText': '該当する記録は見つかりません',
      'loadingText': 'アイテムを読み込んでいます...'
    },
    'dataTable': {
      'itemsPerPageText': '1ページあたりの行数：',
      'ariaLabel': {
        'sortDescending': '降順で並べ替え。',
        'sortAscending': '昇順で並べ替えられます。',
        'sortNone': 'ソートされていません。',
        'activateNone': '並べ替えを削除するには、アクティブにします。',
        'activateDescending': 'アクティブにすると、降順で並べ替えられます。',
        'activateAscending': 'アクティブにすると、昇順で並べ替えられます。'
      },
      'sortBy': '並び替え'
    },
    'dataFooter': {
      'itemsPerPageText': '1ページあたりのアイテム：',
      'itemsPerPageAll': 'すべて',
      'nextPage': '次のページ',
      'prevPage': '前のページ',
      'firstPage': '一ページ目',
      'lastPage': '最後のページ',
      'pageText': '{0}-{1}の{2}'
    },
    'datePicker': {
      'itemsSelected': '{0}が選択されました',
      'nextMonthAriaLabel': '来月',
      'nextYearAriaLabel': '来年',
      'prevMonthAriaLabel': '前月',
      'prevYearAriaLabel': '前年'
    },
    'noDataText': 'データなし',
    'carousel': {
      'prev': '前のビジュアル',
      'next': '次のビジュアル',
      'ariaLabel': {
        'delimiter': '{1}のカルーセルスライド{0}'
      }
    },
    'calendar': {
      'moreEvents': '{0}もっと'
    },
    'fileInput': {
      'counter': '{0}ファイル',
      'counterSize': '{0}ファイル（合計{1}）'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': 'ページネーションナビゲーション',
        'next': '次のページ',
        'previous': '前のページ',
        'page': 'ページに移動{0}',
        'currentPage': '現在のページ、ページ{0}'
      }
    }
  }
}